// Generated by CoffeeScript 1.12.7

/*
== Description

This jQuery plugin makes it possible to trigger CSS transitions that also
change the display property (e.g showing or hiding a modal popup).
Browsers don't transition other properties if the display property is
changed. A solution to this problem is to set a 'transition' class on the
element before starting the transition. The 'transition' class typically sets
the display property to "block" which ensures the element is visible during
the transition.

When called on an element (or collection of elements), this plugin:
- adds a 'transition' class to the element(s)
- runs the given callback (typically setting another class to apply a transition)
- listens for the end of the transition and removes the 'transition' class
 */

(function () {
  'use strict'
  var hasProp = {}.hasOwnProperty

  require('jquery')

  $.bijou.transitionEvent = (function () {
    var el, name, transitionEvents
    el = document.createElement('div')
    transitionEvents = {
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'transitionend',
      'OTransition': 'oTransitionEnd otransitionend',
      'transition': 'transitionend'
    }
    for (name in transitionEvents) {
      if (!hasProp.call(transitionEvents, name)) continue
      if (el.style[name] != null) {
        return transitionEvents[name]
      }
    }
    return null
  })()

  $.fn.toggleTransition = function (callback, done) {
    return this.each(function () {
      var $element, called, timer
      $element = $(this)
      if ($.bijou.transitionEvent) {
        called = false
        $element.one($.bijou.transitionEvent, function () {
          called = true
          clearTimeout(timer)
          $element.removeClass('transition')
          return done != null ? done.call(this) : void 0
        })
        timer = setTimeout(function () {
          if (!called) {
            return $element.trigger($.bijou.transitionEvent)
          }
        }, 700)
        $element.addClass('transition').width()
      }
      if (callback != null) {
        callback.call(this)
      }
      if (!$.bijou.transitionEvent) {
        return done != null ? done.call(this) : void 0
      }
    })
  }
}).call(this)
